const latinCyrillicKazakhSymbols =
  'а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB';
export const nameMask = `Z:[${latinCyrillicKazakhSymbols}]:repeated`;

/**
 * @see https://stackoverflow.com/questions/2049502/what-characters-are-allowed-in-an-email-address
 */
const emailSymbols = 'a-zA-Z0-9!#$%&*~_.@+-';

export const emailMask = `E:[${emailSymbols}]:repeated`;
